
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/collaboration",
      function () {
        return require("private-next-pages/collaboration.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/collaboration"])
      });
    }
  